export class TaskTrackingUrl {
  task_id: string;
  task_type: string;
  description: string;
  tracking_url: string;

  constructor(item: any) {
    this.task_id = item.task_id;
    this.task_type = item.task_type ? item.task_type : item.task?.task_type;
    this.description = item.task?.description;
    this.tracking_url = item.tracking_url;
  }
}
